import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  profile: any;
  nickname: string;

  constructor(public auth: AuthService) {
    var profile_text = localStorage.getItem('profile');
    if (profile_text) {
      this.profile = JSON.parse(profile_text);
      if (this.profile) {
        this.nickname = this.profile.nickname;
      }
    }
    this.auth.onProfileUpdated.subscribe(newProfile => {
      this.profile = newProfile;
    });
  }

  ngOnInit() { }

}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/includes/header/header.component.ts